import { render, staticRenderFns } from "./ReportMaterialsConsumptionEditor.vue?vue&type=template&id=70dd1376&"
import script from "./ReportMaterialsConsumptionEditor.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsConsumptionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QItem,QCheckbox,QList,QItemSection,QItemLabel,QInput,QSelect,QField,QOptionGroup,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QItem,QCheckbox,QList,QItemSection,QItemLabel,QInput,QSelect,QField,QOptionGroup,QSeparator,QCardActions,QBtn}, component.options.components || {})
